import { graphql } from 'react-relay';

import createMutation from '../relay/createMutation';

const mutation = graphql`
  mutation SendSystemNotificationMutation(
    $input: SendSystemNotificationMutationInput!
  ) {
    sendSystemNotification(input: $input) {
      clientMutationId
    }
  }
`;

export default variables => createMutation(mutation)(variables);



// WEBPACK FOOTER //
// ./src/mutations/SendSystemNotificationMutation.js